import React, {useState} from 'react'
import {ExternalResultUrlText} from './styles'

export const ExternalSiteUrl = ({url}) => {
  const [truncate, setTruncate] = useState(true)

  return (
    <ExternalResultUrlText
      truncate={truncate}
      onClick={() => setTruncate(!truncate)}
      data-testing="result-breadcrumb"
    >
      {url}
    </ExternalResultUrlText>
  )
}
